
import { defineComponent } from 'vue';
import FbxButton from '@/components/fbx-button.vue';

export default defineComponent({
    components: {
        FbxButton,
    },
    computed: {
        networkTimeout(): boolean {
            return this.$store.getters.networkTimeout;
        },
    },
    data(): {
        online: boolean;
    } {
        return {
            online: navigator.onLine,
        };
    },
    mounted() {
        window.addEventListener('online', this.onchange);
        window.addEventListener('offline', this.onchange);
        this.onchange();
    },
    methods: {
        onchange() {
            this.online = navigator.onLine;
        },
        retry() {
            if (this.networkTimeout) {
                this.$router.go(0);
            }
        },
    },
    name: 'OfflineModal',
});
